module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"nl-NL":{"subheading":"Woning"}}')
  delete Component.options._Ctor
}
